// extracted by mini-css-extract-plugin
export default {"overlayLoader":"BimWorkOrderOtherActKc2Details_overlayLoader__2NHn3"};